<template>
  <div :class="mapVisibility ? 'field_report_wrapper_nomargin' : 'field_report_wrapper'" v-if="canEdit || canDelete"
    v-cloak>
    <div class="field_report_title_holder" v-show="!mapVisibility">
      <search-input :parentClass="'field_report_filter_search'" placeholder="Caută ..."
        @search="searchByText"></search-input>
    </div>
    <div v-show="!mapVisibility" class="field_report_title_holder">
      <div class="field_report_title_text">{{ this.$t("common.field_report") }}</div>
      <b-button v-if="false" class="field_report_edit_icon" variant="outline-secondary" size="sm" pill @click="changeSelectionMode"><img
          src="@/assets/images/icons/edit.svg" /></b-button>
      <b-button class="field_report_add_icon" variant="outline-secondary" size="sm" pill @click="showTransactions"><img
          src="@/assets/images/icons/plus.svg" /></b-button>
    </div>
    <div class="field-report-map-wrapper" v-if="mapVisibility">
      <google-map ref="map" :showMap="mapVisibility" :selection_mode="false" :parcel_uuid="selected_parcel_uuid_for_map"
        :initMapInMount="true" @onParcelClicked="showParcelInfo" @showToastMessage="showToastMessage"
        @onMapReady="onMapReady" :parcelInfoDialogVisibility="cellInfoVisibility"></google-map>

      <parcel-info-dialog :showPopup="cellInfoVisibility" @hidden="hideParcellInfo" :filters="workListFilters"
        @closeAndSwitchToList="hideParcellInfoAndShowList" :season="currentSeason"
        :parcel_uuid="selected_parcel_uuid_for_map" :parcel_name="selected_parcel_name_for_map"
        :parcel_surface="selected_parcel_surface_for_map" :layer="selected_layer"></parcel-info-dialog>
    </div>
    <FieldReportList v-show="!mapVisibility" ref="fieldReportList" :filterData="filterData"></FieldReportList>
    <mobile-footer :menuItems="footerMenuItems"></mobile-footer>
    <toast-message ref="toastMessage"></toast-message>
    <transactions :showPopup="transactionsVisibility" @hidden="hideTransactions"
      @showTransactionMessage="showTransactionMessage"></transactions>
  </div>
  <div v-else>
    <forbidden></forbidden>
  </div>
</template>

<script>
import FieldReportList from "./partials/fieldReportList.vue";
import MobileFooter from "../../components/Mobile/Footer.vue";
import SearchInput from "../../components/Mobile/searchInput.vue";
import ToastMessage from "../../components/Mobile/toastMessage.vue";
import Transactions from "./dialogs/transactions.vue";
import { canDelete, canEdit, permissions, permissionTypes } from "~/helpers/Permissions";
import Forbidden from "~/pages/errors/Forbidden.vue";
import GoogleMap from "@/components/Map/GoogleMap.vue";
import ParcelInfoDialog from "../works/applyArticles/dialogs/parcelInfoDialog.vue";

export default {
  layout(context) {
    return "noheader";
  },
  name: "FieldReportMobile",
  data() {
    return {
      transactionsVisibility: false,
      currentModuleCode: "FIELD_REPORT",
      selectionMode: false,
      footerMenuItems: [
        {
          code: "FIELD_REPORT",
          spacer: false,
          image: "products_icon_gray.svg",
          selected_image: "products_icon.svg",
          text: this.$t("field_report_mobile.sub_title"),
          event: this.showFieldReport,
          selected: true,
        },
        {
          spacer: true,
          event: "",
        },
        {
          code: "MAP",
          spacer: false,
          image: "pin_inactive.svg",
          selected_image: "pin.svg",
          text: "Hartă",
          event: this.showMap,
          selected: false,
        },
        {
          spacer: true,
          event: "",
        },
        {
          code: "REPORTS",
          spacer: false,
          image: "report_icon.svg",
          selected_image: "report_icon_green.svg",
          text: "Rapoarte",
          event: this.showReports,
          selected: false,
        },
      ],
      filterData: {
        find_all_fields: "",
      },
      mapVisibility: false,
      currentSeason: "",
      local_seasons: this.seasons ? this.seasons : [],
      selected_parcel_uuid_for_map: null,
      selected_parcel_name_for_map: null,
      selected_parcel_surface_for_map: null,
      selected_layer: null,
      cellInfoVisibility: false,
      workListFilters: {},
      isMapReady: false,
    };
  },
  components: {
    Forbidden,
    FieldReportList,
    MobileFooter,
    SearchInput,
    ToastMessage,
    Transactions,
    GoogleMap,
    ParcelInfoDialog,
  },
  computed: {
    config() {
      return {
        permission: permissions.FIELD_REPORT,
        permission_type: permissionTypes.module,
      };
    },
    canEdit() {
      return canEdit(this);
    },
    canDelete() {
      return canDelete(this);
    },
  },
  watch: {},
  methods: {
    showFieldReport() {
      this.currentModuleCode = "FIELD_REPORT";
      this.setActiveFooterMenu("FIELD_REPORT");
      this.mapVisibility = false;
    },
    showMap() {
      this.currentModuleCode = "MAP";
      this.setActiveFooterMenu("MAP");
      this.mapVisibility = true;
    },
    showReports() {
      // this.currentModuleCode = 'REPORTS';
      // this.setActiveFooterMenu('REPORTS');
      this.$refs.toastMessage.showInfo("Funcția este în curs de dezvoltare!");
    },
    searchByText(searchText) {
      this.$set(this.filterData, "find_all_fields", searchText);
    },
    showTransactions() {
      this.transactionsVisibility = true;
    },
    hideTransactions() {
      this.transactionsVisibility = false;
    },
    showTransactionMessage(message) {
      this.$refs.toastMessage.showSuccess(message);
      this.$refs.fieldReportList.reloadList();
    },
    setActiveFooterMenu(code) {
      this.footerMenuItems.forEach((menu_item) => {
        if (menu_item.code == code) {
          menu_item.selected = true;
        } else if (!menu_item.spacer) {
          menu_item.selected = false;
        }
      });
    },
    showToastMessage(type, message) {
      this.$refs.toastMessage.showToastMessage(type, message);
    },
    showParcelInfo(layer) {
      if (layer && layer.parcel_uuid) {
        this.selected_parcel_uuid_for_map = layer.parcel_uuid;
        this.selected_parcel_name_for_map = layer.name;
        this.selected_parcel_surface_for_map = layer.surface.toString();
        this.selected_layer = layer;
        this.workListFilters.src = "map";
        this.cellInfoVisibility = true;
      }
    },
    hideParcellInfo() {
      this.cellInfoVisibility = false;
    },
    hideParcellInfoAndShowList() {
      this.cellInfoVisibility = false;
      this.mapVisibility = false;
      this.setActiveFooterMenu("FIELD_REPORT");
    },
    onMapReady(map) {
      this.isMapReady = Boolean(map);
    },
    changeSelectionMode() {
      this.$refs.toastMessage.showInfo('Funcția este în curs de dezvoltare!');
    },
  },
  mounted() { },
};
</script>

<style lang="scss">
body {
  background-color: #f5f5f5;
}

.toastStyle {
  z-index: 6010;
}

@import "@/assets/scss/fieldReport/fieldReport.scss";
</style>
